export default "__VITE_ASSET__ByFN5gqN__"